import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/cors/auth.guard';

const routes: Routes = [
  {
    path: 'log',
    loadChildren: () => import('./connected/connected.module').then((m) => m.ConnectedModule),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    loadChildren: () => import('./visitor/visitor.module').then((m) => m.VisitorModule)
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}